/**
 *  Created by daiwenjuan on 2018/3/14 上午11:14.
 */
import { app as api } from '@ekuaibao/whispered'
import { getNodeValueByPath } from '@ekuaibao/lib/lib/lib-util'

export function inputInvoiceImport(object) {
  let importResult = []
  let { bus, dataSource = {} } = this.props
  let { id } = dataSource
  let { currentSpecification, submitterId } = this.state
  if (!submitterId) {
    submitterId = this.props.submitterId
  }
  return bus.getValue().then(value => {
    let { details = [] } = value //用来判定是否重复导入
    const invoices = getNodeValueByPath(value, 'invoiceForm.invoices', [])
    const isWholeInvoiceDetail = !!invoices.length
    details = object.details ? [...details, ...object.details] : [...details]
    if (object && object.editDetailObject) {
      object.editDetailObject.isWholeInvoiceDetail = isWholeInvoiceDetail
    }
    return api
      .open('@bills:ImportInputInvoiceModal', {
        details,
        invoices,
        flowId: id,
        visibilityFeeTypes: object.visibilityFeeTypes,
        billSpecification: currentSpecification,
        submitterId,
        onChange: onChange.bind(this, importResult)
      })
      .then(data => {
        if (data && data.master) {
          //在上一层取消的时候会调用emitOK,不知道什么逻辑，所以在这里判断一下
          return api.open('@bills:ImportInvoiceDetailModal', {
            invoiceList: [data], // 手录发票入口
            visibilityFeeTypes: object.visibilityFeeTypes,
            billSpecification: currentSpecification,
            source: object.source,
            isBillInvoice: object.isBillInvoice,
            submitterId,
            flowId: id,
            importType: 'input',
            editDetailObject: object.editDetailObject,
            isSupplyInvoice: object.isSupplyInvoice,
            invoices: object.invoices,
            bus,
            importMode: object.importMode
          })
        }
        return Promise.reject()
      })
  })
}

export const importFromPool = async (params) => {
  const { billSpecification, submitterId, invoices } = params
  const items = await api.open('@bills:ImportInvoiceFromPool', {
    billSpecification,
  })
  const invoiceComponent = billSpecification?.components?.find(
    item => item.field === 'invoiceForm'
  )
  return api.open('@bills:ImportInvoiceDetailModal', {
    invoiceList: items,
    billSpecification,
    isBillInvoice: true,
    submitterId,
    source: 'importBill',
    importMode: invoiceComponent?.importMode,
    importType: 'formPoolSelect',
    invoices,
  })
}

function onChange(importResult, consume) {
  importResult.push(consume)
}

function getImportData(details, importResult) {
  return repeatData(details, importResult)
}

export function repeatData(details, importResult) {
  let tempOrders = []
  let detailsMap = listToMap(details)
  let importMap = listToMap(importResult)
  for (let key in importMap) {
    if (!detailsMap[key]) {
      tempOrders.push(importMap[key])
    }
  }
  return tempOrders
}

function listToMap(orders) {
  let map = {}
  orders.forEach(line => {
    let orders = (line && line.feeTypeForm.orders) || []
    let key = ''
    orders.forEach(order => (key += order + '_'))
    map[key] = line
  })
  return map
}
